import { render, staticRenderFns } from "./Compragrupos.vue?vue&type=template&id=3060ddc1&"
import script from "./Compragrupos.vue?vue&type=script&lang=js&"
export * from "./Compragrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports